import { Phone } from 'iconoir-react'
import { ActivityDrawer } from 'app/components/activities/ActivityDrawer'
import { ContactDrawer } from 'app/components/contacts/ContactDrawer'
import { SectionCard } from 'app/components/SectionCard'
import ExportRows from 'app/components/table/ExportRows'
import TableLayout from 'app/components/table/TableLayout'
import { TableCountFooter } from 'app/components/table/TableCountFooter'
import { TableEmptyState } from 'app/components/ui/table-empty-state'
import { AI_AGENT_COLUMN_WEIGHTS } from 'app/table-columns/activities'
import type { UseAiAgentCallLogReturn } from './useAiAgentCallLog'

export type AiAgentCallLogComponentProps = UseAiAgentCallLogReturn

export function AiAgentCallLogComponent({
  activities,
  columns,
  memoizedFilters,
  initialSort,
  drawer,
  loadActivity,
  search,
  focusedContact,
  openContactDrawer,
  handleContactClick,
  closeContactDrawer,
  loadMore,
}: AiAgentCallLogComponentProps) {
  return (
    <SectionCard attached title="All Agent Calls" className="h-screen" contentClassName="min-h-0 grow gap-3 bg-surface">
      <div className="flex h-full w-full grow flex-col overflow-hidden">
        <TableLayout
          filterableColumns={memoizedFilters}
          extraButtons={(columns, columnVisibility) => [
            <ExportRows
              key={1}
              loaderPropertyName={`activities`}
              totalSize={activities?.total ?? 0}
              columns={columns}
              columnVisibility={columnVisibility}
              search={search}
            />,
          ]}
          data={activities}
          loadMore={loadMore}
          defaultColumnWeights={AI_AGENT_COLUMN_WEIGHTS}
          columns={columns as any}
          initialSort={initialSort}
          meta={{
            getRowStyle: (row) => (row?.id === drawer.focusedActivity?.id ? `table-selected-row` : ``),
          }}
          emptyState={
            <TableEmptyState
              icon={<Phone className="h-6 w-6" strokeWidth={1.5} />}
              title="No agent calls yet"
              description="Calls the AI agent handled show up here with their transcript, outcome, and any appointment it booked."
            />
          }
        />
        <TableCountFooter shown={activities?.hits.length ?? 0} total={activities?.total ?? 0} noun="call" />
        <ActivityDrawer
          activity={drawer.focusedActivity}
          isLoading={drawer.isActivityLoading}
          open={drawer.openDrawer}
          onChange={loadActivity}
          onClose={drawer.closeDrawer}
          onContactClick={handleContactClick}
        />
        <ContactDrawer
          contact={focusedContact}
          openDrawer={openContactDrawer}
          onClose={closeContactDrawer}
          onChange={() => {}}
          highlightActivityId={drawer.focusedActivity?.id}
        />
      </div>
    </SectionCard>
  )
}
